import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackService {
  constructor(private snackBar: MatSnackBar) {}

  showSuccess(msg) {
    this.snackBar.open(msg, 'x', {
      duration: 3000,
      panelClass: ['success-snackbar'],
    });
  }

  showWarning(msg) {
    this.snackBar.open(msg, 'x', {
      duration: 3000,
      panelClass: ['warning-snackbar'],
    });
  }

  showError(msg) {
    this.snackBar.open(msg, 'x', {
      duration: 7000,
      panelClass: ['error-snackbar'],
    });
  }
}
